import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.params
    ? _c(
        "div",
        { staticClass: "tsg-engine-controls-header" },
        [
          _c(
            "div",
            { staticClass: "ag-header-group-cell-label ag-sticky-label" },
            [
              _c("span", { staticClass: "ag-header-group-text" }, [
                _vm._v(_vm._s(_vm.params.headerName || "")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "feature-toggle",
            { attrs: { toggle: _vm.enableTSGLevelEngineRuns } },
            [
              !_vm.params.isUnitManagerView &&
              _vm.params.toolStoreGroupKey &&
              _vm.showEngineControls
                ? _c(
                    "div",
                    { staticClass: "engine-buttons-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "engine-column" },
                        [
                          _c(
                            "tooltip",
                            {
                              attrs: {
                                value: _vm.strategicEngineTooltipContent,
                                position: "bottom-right",
                              },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  class: [
                                    "refresh-button",
                                    `${
                                      _vm.hasUnsavedKpiResults &&
                                      !_vm.isThisTsgCalculatingStrategic
                                        ? "unsaved-kpis"
                                        : ""
                                    }`,
                                  ],
                                  attrs: {
                                    depressed: "",
                                    loading: _vm.isThisTsgCalculatingStrategic,
                                    disabled:
                                      !_vm.isEditable ||
                                      !_vm.engineCanRun ||
                                      _vm.calculatingScenarioElasticityResults ||
                                      _vm.hasUnsavedKpiResults ||
                                      _vm.isBlockedByOtherRun,
                                  },
                                  on: { click: _vm.recalculateStrategic },
                                },
                                [_c("cog-play-icon")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.lastTriggeredInfo.strategic_engine_full_run
                            ? _c("last-triggered-info", {
                                attrs: {
                                  "last-triggered-info": _vm.get(
                                    _vm.lastTriggeredInfo
                                      .strategic_engine_full_run,
                                    _vm.params.toolStoreGroupKey,
                                    {}
                                  ),
                                  loading:
                                    _vm.isLastTriggeredLoading.strategic_engine,
                                  source: "strategic_engine_full_run",
                                  width: 80,
                                  simplified: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "feature-toggle",
                        { attrs: { toggle: _vm.enablePriceOptimisation } },
                        [
                          _c(
                            "div",
                            { staticClass: "engine-column" },
                            [
                              _c(
                                "tooltip",
                                {
                                  attrs: {
                                    value:
                                      _vm.crossElasticityEngineTooltipContent,
                                    position: "bottom-right",
                                  },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass:
                                        "refresh-button cross-elasticity-button",
                                      attrs: {
                                        depressed: "",
                                        loading:
                                          _vm.isThisTsgCalculatingElasticity,
                                        disabled: !_vm.canRunOptimisation,
                                      },
                                      on: {
                                        click:
                                          _vm.runCrossElasticityOptimisation,
                                      },
                                    },
                                    [_c("circles-play-icon")],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("last-triggered-info", {
                                attrs: {
                                  "last-triggered-info": _vm.get(
                                    _vm.lastTriggeredInfo
                                      .cross_elasticity_engine,
                                    _vm.params.toolStoreGroupKey,
                                    {}
                                  ),
                                  loading:
                                    _vm.isLastTriggeredLoading
                                      .cross_elasticity_engine,
                                  source: "cross_elasticity_engine",
                                  "translation-time-key":
                                    "gridView.optimisationLastRunTime",
                                  width: 80,
                                  simplified: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }